package fr.manyverse.app.infrastructure.image

actual fun getImageCacheDirectory(): String {
    // Browser handles cache automatically via HTTP cache headers
    return ""
}
